import { render, staticRenderFns } from "./WordRotator.vue?vue&type=template&id=59879cd4&"
import script from "./WordRotator.vue?vue&type=script&lang=ts&"
export * from "./WordRotator.vue?vue&type=script&lang=ts&"
import style0 from "./WordRotator.vue?vue&type=style&index=0&id=59879cd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports